<template>
  <v-row dense>
    <v-col cols="12" sm="6">
      <px-select-enum
        dense
        label="Campo"
        class="required rounded-tag-small"
        :error="$v.criterio.campo.$error"
        @blur="$v.criterio.campo.$touch()"
        v-model="criterio.campo"
        :items="opcoesCriterios"
        @change="onChangeCampo"
      />
      <v-switch dense v-if="exibirExcecao"
                class="pa-0 mt-2 mr-2"
                color="primary"
                v-model="criterio.excecao">
        <template v-slot:label>
          Aplicar como exceção
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon right small v-on="on">mdi-information-outline</v-icon>
            </template>
            <span>
              Quando marcado, será considerado todos os itens do <b>Campo</b>,
              com exceção dos itens selecionados
            </span>
          </v-tooltip>
        </template>
      </v-switch>
    </v-col>
    <v-col cols="12" sm="6" class="d-flex">
      <px-criterio
        :tipo-criterio="criterio.campo"
        :metadata="criterioMetadata"
        :error="$v.criterio.values.$error"
        :criterios-enum="criteriosEnum"
        @blur="$v.criterio.values.$touch()"
        v-model="criterio.values"
      />
      <v-btn icon @click="onClickRemove">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import PxCriterio from '@/modules/alcadas/components/criterios/PxCriterio.vue';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    criterio: Object,
    opcoesCriterios: Array,
    criteriosEnum: Array,
  },
  methods: {
    onClickRemove() {
      this.$emit('remove');
    },
    onChangeCampo() {
      this.criterio.values = null;
    },
    isValid() {
      return !this.validateForm();
    },
  },
  computed: {
    exibirExcecao() {
      const criterio = this.criteriosEnum.find(item => item.key === this.criterio.campo);
      if (!criterio) {
        return false;
      }
      return criterio.supportsException;
    },
    criterioMetadata() {
      const opcaoCriterio = this.opcoesCriterios.find(item => item.key === this.criterio.campo);
      if (opcaoCriterio && opcaoCriterio.type) {
        return {
          type: opcaoCriterio.type,
          label: opcaoCriterio.description,
        };
      }
      return null;
    },
  },
  components: {
    PxCriterio,
  },
  validations: {
    criterio: {
      campo: {
        required,
      },
      values: {
        required,
      },
    },
  },
};
</script>
